module.exports = __webpack_public_path__ + "static/media/kozama.080c7156.png";